import React from 'react';
import { Calendar, Trash2, Search, Wallet } from 'lucide-react';

const ExpenseList = ({ expenses, filteredExpenses, filterCategory, setFilterCategory, categories, getCategoryGradient, handleDeleteClick, setOpenClearAllDialog, onExpenseClick }) => {
  return (
    <div className="bg-white/90 backdrop-blur-xl rounded-3xl p-8 border border-pink-200 shadow-xl">
      <div className="flex items-center justify-between mb-5 flex-wrap gap-3">
        <div className="flex items-center">
          <div className="p-2 bg-gradient-to-br from-orange-400 to-red-600 rounded-xl mr-3 shadow-lg">
            <Calendar className="w-5 h-5 text-white" />
          </div>
          <h2 className="text-xl font-bold text-gray-900">Recent Transactions</h2>
        </div>
        
        <div className="flex flex-wrap items-center gap-3">
          <div className="relative flex-grow">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
            <input
              type="text"
              placeholder="Filter by category..."
              value={filterCategory}
              onChange={(e) => setFilterCategory(e.target.value)}
              className="w-full pl-9 pr-3 py-2 bg-gray-50 border border-gray-200 rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-400 text-sm transition-all"
            />
          </div>
          {expenses.length > 0 && (
            <button
              onClick={() => setOpenClearAllDialog(true)}
              className="px-4 py-2 bg-red-50 border border-red-200 text-red-600 rounded-lg hover:bg-red-100 font-semibold transition-all duration-200 text-sm flex-shrink-0 shadow-sm hover:shadow-md"
            >
              Clear All
            </button>
          )}
        </div>
      </div>

      <div className="overflow-x-auto">
        {filteredExpenses.length === 0 ? (
          <div className="text-center py-12">
            <div className="inline-block p-5 bg-gradient-to-br from-blue-100 to-indigo-100 rounded-2xl mb-4">
              <Wallet className="w-14 h-14 text-blue-600" />
            </div>
            <p className="text-gray-600 font-medium text-base">No transactions found</p>
          </div>
        ) : (
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-gray-200">
                <th className="text-left py-3 px-4 text-gray-700 font-bold">Date</th>
                <th className="text-left py-3 px-4 text-gray-700 font-bold">Category</th>
                <th className="text-left py-3 px-4 text-gray-700 font-bold">Description</th>
                <th className="text-right py-3 px-4 text-gray-700 font-bold">Amount</th>
                <th className="text-center py-3 px-4 text-gray-700 font-bold">Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredExpenses.map((expense, idx) => {
                const gradient = getCategoryGradient(expense.category);
                return (
                  <tr
                    key={expense._id}
                    className="border-b border-gray-100 hover:bg-gradient-to-r hover:from-blue-50 hover:to-indigo-50 transition-all duration-200 group cursor-pointer"
                    style={{animation: `fadeIn 0.4s ease-in-out ${idx * 0.1}s backwards`}}
                    onClick={() => onExpenseClick && onExpenseClick(expense._id)}
                  >
                    <td className="py-3 px-4 text-gray-700 font-medium">{expense.date}</td>
                    <td className="py-3 px-4">
                      <span className={`inline-block px-3 py-1.5 rounded-lg bg-gradient-to-r ${gradient} text-white text-xs font-semibold shadow-sm`}>
                        {categories.find(c => c.value === expense.category)?.label || expense.category}
                      </span>
                    </td>
                    <td className="py-3 px-4 text-gray-600 font-normal">{expense.description || '-'}</td>
                    <td className="py-3 px-4 text-right text-gray-900 font-bold text-md">₹{expense.amount.toFixed(2)}</td>
                    <td className="py-3 px-4 text-center">
                      <button
                        onClick={() => handleDeleteClick(expense._id)}
                        className="p-1.5 bg-red-50 border border-red-200 text-red-600 rounded-lg hover:bg-red-100 transition-all duration-200 shadow-sm hover:shadow-md"
                      >
                        <Trash2 className="w-4 h-4" />
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default ExpenseList;
